<template>
<v-container>
    <v-row no-gutters>
        <v-col
            cols="12"
            md="4"
            sm="4"
        >
            <h1>Bills</h1>
        </v-col>
        <v-col
            cols="12"
            md="4"
            sm="4"
        >
            <v-switch
              v-model="gmwswitch"
              color="red"
              label="GMW"
              hide-details
            ></v-switch>
        </v-col>
        
        <v-spacer></v-spacer>
        <v-row justify="center">
            <!-- <v-col cols="auto">
                <v-btn color="blue" @click="createformvoice()" >
                    Voice Bill Beta
                </v-btn>
            </v-col> -->
            <v-col cols="auto">
                <v-btn color="purple" @click="gmgmwform()" >
                    GM-GMW Bill
                </v-btn>
            </v-col>
            <v-col cols="auto">
                <v-btn color="success" @click="createform()" >
                    New Bill
                </v-btn>
            </v-col>
        </v-row>
        
        
    </v-row>
    <v-data-table
        :headers="headers"
        :items="filteredBills"
    >
        <template v-slot:thead>
            <tr>
                <td>
                    <v-text-field v-model="consearch" class="ma-2" density="compact" placeholder="Con..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="billnosearch" class="ma-2" density="compact" placeholder="Bill No..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="billdatesearch" class="ma-2" density="compact" placeholder="Bill Date..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="partysearch" class="ma-2" density="compact" placeholder="Party..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="addresssearch" class="ma-2" density="compact" placeholder="Address..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="amountsearch" class="ma-2" density="compact" placeholder="Greater Than" hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="casesearch" class="ma-2" density="compact" placeholder="Case..." hide-details></v-text-field>
                </td>
                <td>
                    <v-text-field v-model="transportsearch" class="ma-2" density="compact" placeholder="Transport..." hide-details></v-text-field>
                </td>
            </tr>
        </template>  
        
        <template v-slot:[`item.actions`]="{ item }">
            <v-icon
                class="me-2"
                size="small"
                @click="editItem(item)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                class="me-2"
                size="small"
                @click="printItem(item)"
            >
                mdi-printer
            </v-icon>
        </template>
    </v-data-table>
    <div v-if="showForm">
        <Form :showForm="showForm" :editedItem="editedItem" :editedIndex="editedIndex" :updateID="updateID"  :gmwswitch="gmwswitch" @closedialog="closedialog"/>
    </div>
    <div v-if="showGmGmwForm">
        <GMGMwForm :showGmGmwForm="showGmGmwForm" @closegmgmwdialog="closegmgmwdialog"/>
    </div>
    <div v-if="showVoiceForm">
        <VoiceForm :showVoiceForm="showVoiceForm" :editedItem="editedItem" :editedIndex="editedIndex" :updateID="updateID"  :gmwswitch="gmwswitch" @closedialog="closedialog"/>
    </div>
    <div v-if="showMessage">
        <ShowError @closesnackbar="closesnackbar"/>
    </div>
</v-container>
</template>

<script setup>
    import { ref, provide, computed, onMounted,onBeforeMount, watch } from 'vue'
    import { useAuthStore } from '@/stores/AuthStore'
    import { useBatchStore } from '@/stores/BatchStore'
    import BatchService from '@/services/BatchService'
    import BillService from '@/services/BillService'
    import Form from '@/views/bills/form'
    import VoiceForm from '@/views/bills/voiceform'
    import GMGMwForm from '@/views/bills/gmtowsform'
    import ShowError from '@/components/Showerror'
    import router from '@/router'

    const authStore = useAuthStore()
    const batchStore = useBatchStore()

    var gmwswitch = ref(authStore.gmswitch)
    var bills = ref([])
    var gmbills = ref([])
    var gmwbills = ref([])
    var showMessage = ref(false)
    var msgStatus = ref('primary')
    var msg = ref('This is msg')

    //searchs
    var consearch = ref('')
    var billdatesearch = ref('')
    var billnosearch = ref('')
    var partysearch = ref('')
    var addresssearch = ref('')
    var amountsearch = ref('')
    var casesearch = ref('')
    var transportsearch = ref('')

    var showForm=ref(false)
    var editedIndex = ref(-1)
    var editedItem = ref({
        productsales:[]
    })
    var updateID = ref(0)

    var showGmGmwForm=ref(false)

    var showVoiceForm=ref(false)


    provide('msgStatus', msgStatus)
    provide('msg', msg)
    provide('showMessage', showMessage)

    var headers = ref([
        {
          title: 'Console',
          align: 'start',
          sortable: true,
          key: 'console',
        },
        { title: 'Bill No', key: 'billno' },
        { title: 'Bill Date', key: 'billdate' },
        { title: 'Partyname', key: 'bills_partyname' },
        { title: 'Address', key: 'party.address' },
        { title: 'Amount', key: 'billamount' },
        { title: 'Case', key: 'caseno' },
        { title: 'Transport', key: 'transport' },
        { title: 'Actions', key: 'actions', sortable: false },
    ])

    onBeforeMount(async () => {
        var gmbills = await getbillsfromgm()
        var gmwbills = await getbillsfromgmw()
        bills.value = gmwswitch.value ? gmwbills : gmbills
    })

    async function getbillsfromgm(){
        try{
            var bills = (await BillService.getall()).data
            gmbills.value = bills
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        return bills
        
    }

    async function getbillsfromgmw(){
        try{
            var bills = (await BillService.getallgmw()).data
            gmwbills.value = bills
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        
        return bills
    }

    async function editItem(item){
        editedIndex.value = bills.value.indexOf(item)
        updateID.value = item.billid
        var bill = gmwswitch.value ? (await BillService.getbillgmw(item.billid)).data : (await BillService.getbill(item.billid)).data
        editedItem.value = Object.assign({}, bill)
        showForm.value = true
    }

    async function printItem(item){
        //console.log(item)
        var response = gmwswitch.value ?(await BillService.printinvoicegmw(item.billid)) : (await BillService.printinvoice(item.billid))
        //console.log(response)
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        //link.download = 'test.pdf'
        window.open(link, '_blank').focus();
    }

    function createform(){
        showForm.value = true
    }

    function gmgmwform(){
        //console.log("GM GMW form is called")
        showGmGmwForm.value = true
        //console.log(showGmGmwForm.value)
    }

    function createformvoice(){
        //console.log("Show Voice Form Clicked")
        showVoiceForm.value = true
        //console.log(showVoiceForm.value)
    }


    function closesnackbar (){
        showMessage.value = false
    }

    function closedialog (){
        //console.log('Close dialog is called')
        showForm.value = false
        router.go(0)
    }

    function closegmgmwdialog (){
        //console.log('Close gmgw dialog is called')
        showGmGmwForm.value = false
        router.go(0)
    }

    watch(gmwswitch, async(val)=>{
        authStore.setGmswitch()
        bills.value = gmwswitch.value ? gmwbills.value : gmbills.value
    })

    //filters
    function filterCon(item){
        return item.console.toLowerCase().includes(consearch.value.toLowerCase())
    }

    function filterBillno(item){
        return item.billno.toLowerCase().includes(billnosearch.value.toLowerCase())
    }
    function filterBilldate(item){
        return item.billdate.toLowerCase().includes(billdatesearch.value.toLowerCase())
    }

    function filterParty(item){
        return item.bills_partyname.toLowerCase().includes(partysearch.value.toLowerCase())
    }
    function filterAddress(item){
        return item.party.address.toLowerCase().includes(addresssearch.value.toLowerCase())
    }
    function filterAmount(item){
        return item.billamount >= amountsearch.value
    }
    function filterCase(item){
        return item.caseno >= casesearch.value
    }
    function filterTransport(item){
        return item.transport.toLowerCase().includes(transportsearch.value.toLowerCase())
    }

    const filteredBills = computed(() => {
        var conditions = []

        if(consearch.value){
            conditions.push(filterCon)
        }

        if(billnosearch.value){
            conditions.push(filterBillno)
        }

        if(billdatesearch.value){
            conditions.push(filterBilldate)
        }

        if(partysearch.value){
            conditions.push(filterParty)
        }

        if(addresssearch.value){
            conditions.push(filterAddress)
        }

        if(amountsearch.value){
            conditions.push(filterAmount)
        }
        if(casesearch.value){
            conditions.push(filterCase)
        }
        if(transportsearch.value){
            conditions.push(filterTransport)
        }

        if(conditions.length > 0){
            return bills.value.filter((bill) => {
                return conditions.every((condition) => {
                    return condition(bill)
                })
            })
        }

        return bills.value
    })
</script>
